<template>
  <v-container v-if="!!dataset">
    <toolbar mode="dataset" :item="dataset" />
    <dataset ref="dataset" v-if="dataset" :item="dataset" @submitted="onSubmit"></dataset>
  </v-container>
</template>

<script>
import toolbar from "@/components/toolbar"
import dataset from "@/components/Forms/Dataset"
import Datasets from "@/api/datasets"
export default {
  name: "Edit",
  components: {
    toolbar,
    dataset
  },
  data() {
    return {
      dataset: undefined
    }
  },
  mounted() {
    Datasets.retrieve(this.$route.params.uuid).then(response => this.dataset = response.data)
  },
  methods: {
    onSubmit(dataset) {
      this.$refs.dataset.working = true
      Datasets.update(this.dataset.uuid, {
        name: dataset.name,
        completion: dataset.completion,
        production: dataset.production,
        economic: dataset.economic,
        identifier: dataset.identifier,
        filters: dataset.filters,
        owner: this.user.id
      })
        .then(response => {
          this.notify("Updating dataset")
          this.$router.push({ name: "datasetShow", params: { uuid: response.data.uuid } })
        })
        .finally(() => (this.$refs.dataset.working = false))
    }
  }
}
</script>
